import { Injectable, signal } from '@angular/core';

@Injectable({providedIn: 'root'})
export class ThemeService {
  darkModeEnabled = signal(
      localStorage.getItem('theme') === 'dark'
    );

    constructor() {
      this.applyTheme(this.darkModeEnabled());
    }

    toggleDarkMode(): void {
      this.darkModeEnabled.update((value) => !value);
      this.applyTheme(this.darkModeEnabled());
      localStorage.setItem('theme', this.darkModeEnabled() ? 'dark' : 'light');
    }

    private applyTheme(isDark: boolean): void {
      if (isDark) {
        document.documentElement.classList.add('dark');
      } else {
        document.documentElement.classList.remove('dark');
      }
    }
}
